<template>
    <div class="block b-left b-right blok-2">
        <div class="row" style="position:relative;">
            <div
                class="mbo-3"
                style="height: 0.625vw;display: block;width: 1px;"
            ></div>
            <div class="col-12 mbo-3">
                <div class="row">
                    <div class="col-6 text-uppercase">contract</div>
                    <div class="col-6 text-right font-weight-bold">
                        <a
                            id="contract-address-withdraw"
                            class="text-green-gradient"
                            target="_blank"
                            :title="vault.contract_address"
                            :href="
                                `${getTokenUrl(vault.network)}/address/${
                                    vault.contract_address
                                }`
                            "
                            >{{ contract }}</a
                        >
                    </div>
                </div>
            </div>
            <div class="col-12 mbo-3">
                <div class="row">
                    <div class="col-6">
                        <label class="text-capitalize">YOUR DEPOSITS</label>
                    </div>
                    <div class="col-6 text-right d-lg-none">
                        <label class="text-capitalize">YOUR BALANCE</label>
                    </div>
                </div>
                <div class="row font-weight-bold">
                    <div class="col-6">
                        <div v-if="walletProvider">
                            <span class="text-lg-1" id="deposit">
                                {{ calcTokenBalance }}
                            </span>
                            <span
                                style="text-transform:uppercase;"
                                class="text-lg-2"
                                id="token"
                            >
                                {{ vault.real_token_symbol }}
                            </span>
                        </div>
                        <span class="text-lg-1" v-else>-</span>
                    </div>
                    <div class="col-6 text-right d-lg-none">
                        <span
                            class="text-lg-1"
                            v-if="premiumLoad"
                            id="balance"
                            >{{ moneyFormat(calcYourPosition) }}</span
                        >
                        <span class="text-lg-1" v-else>-</span>
                    </div>
                </div>
            </div>
            <div class="col-12 mbo-3">
                <label class="text-capitalize">PREMIUM REALIZED</label>
                <div class="font-weight-bold">
                    <div class="row">
                        <div class="col-6">
                            <div v-if="premiumLoad">
                                <span class="text-lg-1" id="premium-realized">{{
                                    calcPremiumRealize
                                }}</span>
                                <span
                                    class="text-lg-2"
                                    style="text-transform:uppercase;"
                                >
                                    {{ vault.real_token_symbol }}</span
                                >
                            </div>
                            <span class="text-lg-1" v-else>-</span>
                        </div>
                        <div class="col-6 text-right">
                            <span
                                class="text-lg-1"
                                v-if="premiumLoad"
                                id="premium"
                                >{{ formatCurrency(calcPremium) }}
                            </span>
                            <span class="text-lg-1" v-else>-</span>
                            <span class="text-lg-2"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6 col-md-12 mbo-3 mob-balance mobile-hidden">
                <label class="text-capitalize">TOTAL BALANCE</label>
                <div class="font-weight-bold">
                    <span class="text-lg-1" v-if="premiumLoad" id="balance">{{
                        formatCurrency(calcYourPosition)
                    }}</span>
                    <span class="text-lg-1" v-else>-</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Decimal from "decimal.js";

export default {
    data() {
        return {
            window: window,
            premiumLoad: true
        };
    },
    computed: {
        ...mapState("il", ["vault", "contract"]),
        ...mapState("wallet", ["tokens"]),
        ...mapGetters({
            walletProvider: "wallet/getWalletProvider",
        }),
        calcTokenBalance() {
            if (!this.walletProvider) return 0;
            const decimal = this.vault.type == "put_selling" ? 2 : 6;

            let token = this.tokens.find(
                item =>
                    item.symbol == this.vault.real_token_symbol &&
                    item.network == this.vault.network
            );

            const tokenBalance = this.vault.userInfo.deposit / token.decimals;

            if (tokenBalance != 0)
                return this.moneyFormat(tokenBalance, decimal);
            else return this.moneyFormat(tokenBalance);
        },
        calcYourPosition() {
            if (!this.walletProvider) return 0;
            const conversion =
                this.vault.type == "put_selling" ? 1 : this.vault.usd_price;

            let token = this.tokens.find(
                item =>
                    item.symbol == this.vault.real_token_symbol &&
                    item.network == this.vault.network
            );

            return (this.vault.userInfo.balance / token.decimals) * conversion;
        },
        calcPremiumRealize() {
            if (!this.walletProvider) return 0;
            // console.log('calc',this.vault.userInfo.maxWithdraw,this.vault.userInfo.activeDeposit);

            let token = this.tokens.find(
                    item =>
                    item.symbol == this.vault.real_token_symbol &&
                    item.network == this.vault.network
            );

            return Decimal(this.vault.userInfo.balance/token.decimals).minus(this.vault.userInfo.activeDeposit).toFixed(6);
            // let premiumRealized = Decimal("0");
            // if (
            //     token &&
            //     this.vault.vault_detail.expiry_timestamp &&
            //     this.vault.userInfo.depositString &&
            //     this.vault.total_asset &&
            //     this.vault.premiums_paid
            // ) {
            //     const expiryTimestamp = this.vault.vault_detail
            //         .expiry_timestamp;
            //     const currentEpochDeposit = Decimal(
            //         this.vault.userInfo.depositString
            //     );
            //     const totalAsset = Decimal(this.vault.total_asset);
            //     const premiumsPaid = Decimal(this.vault.premiums_paid);

            //     if (expiryTimestamp > 0) {
            //         if (totalAsset.toString() !== "0") {
            //             premiumRealized = currentEpochDeposit
            //                 .dividedBy(totalAsset)
            //                 .times(premiumsPaid)
            //                 .dividedBy(token.decimals);
            //         }
            //     } else if (expiryTimestamp === 0) {
            //         const newTotalAsset = totalAsset.plus(premiumsPaid);
            //         if (newTotalAsset.toString() !== "0") {
            //             premiumRealized = currentEpochDeposit
            //                 .dividedBy(newTotalAsset)
            //                 .times(premiumsPaid)
            //                 .dividedBy(token.decimals);
            //         }
            //     }
            // }

            // return premiumRealized.toFixed(6);
        },
        calcPremium() {
            if (!this.walletProvider) return 0;

            const conversion =
                this.vault.type == "put_selling" ? 1 : this.vault.usd_price;
            return (+this.calcPremiumRealize * conversion).toFixed(2);
        }
    },
    methods: {
        formatCurrency(val) {
            const formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });

            return formatter.format(val);
        }
    }
};
</script>
